"use client";
import ClevertapReact from "clevertap-react";
import { getCookie, isEmpty, isWindowPresent } from "src/utils/browserHelpers";

import { isUserSignedIn, path } from "src/utils/generalUtils";
// import { checkInternalCTUser } from "FlightUtils";
const domain = isWindowPresent ? path(["location", "hostname"], window) : [];
const CLEVERTAP_KEY_ID = process.env.NEXT_PUBLIC_CLEVERTAP_KEY || null;

class Clevertap {
  enabled: boolean;
  abData: Record<string, any>;

  constructor() {
    this.enabled = false;
    this.abData = {};
    if (CLEVERTAP_KEY_ID && isWindowPresent) {
      this.enabled = true;
      ClevertapReact.initialize(CLEVERTAP_KEY_ID);
    }
  }
  event = (name: string, payload: Record<string, unknown> = {}) => {
    let ctAb = isEmpty(getCookie("ct-pwa"))
      ? {}
      : JSON.parse(decodeURIComponent(getCookie("ct-pwa")));

    if (this.enabled) {
      const userID = getCookie("userid") || "NA";
      const platform = "DESKTOP";
      const domainName = domain || "NA";
      const isLoggedin = isUserSignedIn() ? "yes" : "no";
      const source = "web";

      payload = {
        ...payload,
        userID,
        platform,
        domainName,
        isLoggedin,
        source,
      };
      if (isEmpty(ctAb)) {
        payload.abDecodeError = "yes";
        ctAb = this.abData;
        if (this.abData) {
          payload.dataPickAbData = "yes";
        }
      }

      payload.bus_supercoin = ctAb["bus_supercoin"];
      payload.bus_conv_fee = ctAb["bus_conv_fee"];

      setTimeout(() => {
        if (isWindowPresent) ClevertapReact.event(name, payload);
      }, 300);
    }
  };
  //   customEvent = (name, payload = {}) => {
  //     const ctAb = isEmpty(getCookie("ct-pwa"))
  //       ? "{}"
  //       : decodeURIComponent(getCookie("ct-pwa"));
  //     if (this.enabled) {
  //       this.abData = JSON.parse(ctAb);
  //       payload.platform = payload.platform || "PWA";
  //       payload.domainName = domain || "NA";
  //       payload.language = getCookie("selectedLanguage")
  //         ? getCookie("selectedLanguage")
  //         : payload.language;
  //       payload.is_logged_in = isUserSignedIn() ? "yes" : "no";
  //       let deviceType = checkDeviceType();
  //       if (deviceType === "iPhoneApp") {
  //         const appVersion =
  //           path(["iosData", "app-version-name"], window) || "N/A";
  //         payload.platform = "iOS";
  //         payload.appType = "webView";
  //         payload.app_version = appVersion;
  //       }
  //       if (deviceType === "AndroidApp") {
  //         const appVersion =
  //           path(["androidData", "app-version-name"], window) || "N/A";
  //         payload.platform = "android";
  //         payload.appType = "webView";
  //         payload.app_version = appVersion;
  //       }
  //       if (payload.apiError) {
  //         payload.abApiError = true;
  //       }
  //       payload.abResponse_abcookie = JSON.stringify(payload);
  //       payload.ctAbResponse_abcookie = ctAb;
  //       setTimeout(() => {
  //         if (deviceType) {
  //           deviceType === "AndroidApp"
  //             ? ClevertapAndroid.event(name, payload)
  //             : ClevertapIos.event(name, payload);
  //         } else {
  //           ClevertapReact.event(name, payload);
  //         }
  //       }, 300);
  //     }
  //   };
  profile = (payload: any) => {
    if (this.enabled && isWindowPresent) {
      ClevertapReact.profile(payload);
    }
  };
  logout = () => {
    if (this.enabled && isWindowPresent) {
      ClevertapReact.logout();
    }
  };
}

const ClevertapObject = new Clevertap();
export default ClevertapObject;
